// extracted by mini-css-extract-plugin
export default {"container":"calendarInput_container__OAwI+","closeIcon":"calendarInput_closeIcon__WM7wt"};